import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { fuseAnimations } from '../../../../../../../core/animations';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { ShiftService } from '../../../../../../services/shifts/shift.service';
import { AuthenticationService } from '../../../../../../services/authentication/authentication.service';
import { DivisionService } from '../../../../../../services/divisions/division.service';
import { Observable } from 'rxjs/Observable';
import { EmployeeService } from '../../../../../../services/employee/employee.service';
import { map, startWith } from 'rxjs/operators';
import { SubjectDivisionTeacherService } from '../../../../../../services/subject-division-teachers/subject-division-teacher.service';
import { TranslationService } from '../../../../../../services/translation/translation.service';


@Component({
    selector: 'fuse-add-edit-subject-teacher',
    templateUrl: 'add-edit-subject-teacher.component.html',
    styleUrls: ['./add-edit-subject-teacher.component.scss'],
    animations: fuseAnimations
})
export class AddEditSubjectTeacherComponent implements OnInit, OnDestroy {
    @BlockUI('tracker-dialog') blockUI: NgBlockUI;
    formGroup;
    mainFormControl;
    substituteFormControl = new FormControl();
    public teachers = [];

    filteredSubstituteTeachers: Observable<string[]>;

    constructor(private authenticationService: AuthenticationService,
                @Inject(MAT_DIALOG_DATA) public data: any,
                public dialogRef: MatDialogRef<AddEditSubjectTeacherComponent>,
                public dialog: MatDialog,
                public divisionService: DivisionService,
                public shiftService: ShiftService,
                private router: Router,
                private fb: FormBuilder,
                public employeeService: EmployeeService,
                public subjectDivisionTeacherService: SubjectDivisionTeacherService,
                private translationService: TranslationService,
                private sweetAlertService: SweetAlertService) {
        this.initializeFormControlValidators();
    }

    ngOnDestroy(): void {
    }

    ngOnInit(): void {
        Observable.combineLatest(
            this.employeeService.getAllTeachers()
        ).subscribe(([teachers]: any) => {
            this.teachers = teachers;
        });

        console.log('this.substituteFormControl', this.substituteFormControl);
        this.data.SubstituteTeacher = this.data.SubstituteTeacher ? this.data.SubstituteTeacher : '';
        this.filteredSubstituteTeachers = this.substituteFormControl.valueChanges
            .pipe(
                startWith<string | any>(this.data.SubstituteTeacher),
                map(value => typeof value === 'string' ? value : value.FullName),
                map(name => name ? this._filter(name) : this.teachers.slice())
            );
    }

    initializeFormControlValidators() {
        this.formGroup = this.fb.group({
            mainFormControl: ['', [Validators.required]],
            substituteFormControl: ['', []],
        });
    }

    checkValidationErrors() {
        setTimeout(() => {
        }, 20);
    }

    save() {
        const mt = this.teachers.find(e => e.Id === this.data.subject.MainTeacher.Id);
        const st = this.teachers.find(e => e.Id === this.data.subject.SubstituteTeacher.Id);
        if (mt) {
            this.blockUI.start();
            const data = {
                DivisionId: this.data.divisionId,
                SubjectId: this.data.subject.SubjectId,
                MainTeacherId: this.data.subject.MainTeacher.Id,
                SubstituteTeacherId: this.data.subject.SubstituteTeacher.Id
            };

            this.subjectDivisionTeacherService.add(data).subscribe(response => {
                console.log(response);
                if (response.ResultCode === 1) {
                    this.data.subject.MainTeacher.FirstName = mt.FirstName;
                    this.data.subject.MainTeacher.LastName = mt.LastName;

                    this.data.subject.SubstituteTeacher.FirstName = st ? st.FirstName : '';
                    this.data.subject.SubstituteTeacher.LastName = st ? st.LastName : '';

                    this.dialogRef.close(this.data.subject);

                    this.blockUI.stop();
                    this.translationService.translate('LABELS.CORRECTLY_ADDED', this.translationService.teacher, (res) => {
                        this.sweetAlertService.success(this.translationService.success, res, null);
                    });
                } else {
                    this.blockUI.stop();
                    this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                        this.sweetAlertService.error('Error', res, null);
                    });
                }
            }, error => {
                this.blockUI.stop();
                this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            });
        }
    }

    private _filter(value: any): any[] {
        const filterValue = value.toLowerCase();
        return this.teachers.filter(option => option.FullName.toLowerCase().includes(filterValue));
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/subject-division-teacher/components/add-subject-teacher/add-edit-subject-teacher.component.ts